import { useCallback } from 'react';
import { useDefinitionResource } from 'src/components/star-grid/hooks/useDefinitionResource';
import { suggestScenarioMap } from 'src/components/star-grid/datasets/services/datasetService';
import type { DatasetFixedFilter, ScenarioSuggestionsResponse } from 'src/components/star-grid/datasets/datasetTypes';

const NONE: ScenarioSuggestionsResponse = { values: [], months: {}, period: null, suggestions: [], unread: [] };

/** Every value of the scenario column and the suggested scenario map over them; read once the column is known. */
export function useScenarioSuggestions(
  ref: string | null,
  column: string | undefined,
  time: { readonly column?: string; readonly format?: string },
  fixedFilters: readonly DatasetFixedFilter[],
  roleArn: string | undefined,
  enabled: boolean
) {
  const { column: timeColumn, format: timeFormat } = time;
  const fetcher = useCallback(
    (signal: AbortSignal): Promise<ScenarioSuggestionsResponse> =>
      enabled && ref && column
        ? suggestScenarioMap(ref, column, { column: timeColumn, format: timeFormat }, signal, fixedFilters, roleArn)
        : Promise.resolve(NONE),
    [enabled, ref, column, timeColumn, timeFormat, fixedFilters, roleArn]
  );
  const resource = useDefinitionResource(fetcher);
  return { ...(resource.data ?? NONE), loading: resource.loading, error: resource.error?.message ?? null };
}
